export default "__VITE_ASSET__D9RhStFu__"